import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.widget.outputs');
import { OnInit, Input, HostListener, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Chart, ChartConfiguration } from 'chart.js';
import { Router } from '@angular/router';

interface Metric {
    key: string;
    label: string;
    value: number;
    iconSrc: string;
}

const METRIC_META = [
    { key: 'totalOutputs', label: '총 성과물', iconSrc: 'assets/images/researcher_detail/result_32.svg', unit: "건", group: 'outputs' },
    { key: 'papers', label: '논문', iconSrc: 'assets/images/researcher_detail/thesis_32.svg', unit: "건", group: 'outputs' },
    { key: 'patents', label: '특허', iconSrc: 'assets/images/researcher_detail/patent_32.svg', unit: "건", group: 'outputs' },
    { key: 'reports', label: '보고서', iconSrc: 'assets/images/researcher_detail/report_32.svg', unit: "건", group: 'outputs' },
    { key: 'institutions', label: '협력 연구기관', iconSrc: 'assets/images/researcher_detail/Joint_research_institute_32.svg', unit: "개", group: 'collab' },
    { key: 'collaborators', label: '협력 연구자', iconSrc: 'assets/images/researcher_detail/Collaborating_Researcher_32.svg', unit: "명", group: 'collab' },
];

type OutputModalItem = {
    kind: 'output';
    title: string;
    doc_num?: string;
    category?: string;
    year?: number;
};

type OrgModalItem = {
    kind: 'organization';
    title: string;
};

type CollaboratorModalItem = {
    kind: 'collaborator';
    id: string;
    name: string;
    org: string;
};

type ModalItem = OutputModalItem | OrgModalItem | CollaboratorModalItem;

@Component({
    selector: 'wiz-portal-overview-widget-outputs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.widget.outputs/view.scss */
/* src/app/portal.overview.widget.outputs/view.scss: no such file or directory */`],
})
export class PortalOverviewWidgetOutputsComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public researcher: any;
    public products: any[] = [];
    public filtered: any[] = [];
    public periodStart = 0;
    public periodEnd = 0;
    metrics: Metric[] = [];

    public outputM: any;
    public collabM: any;
    public etcM: any;

    // 모달 상태
    public modalOpen = false;
    public modalTitle = '';
    public modalSubtitle = '';
    public modalItems: ModalItem[] = [];
    public modalMessage: string | null = null;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.recalculate();
            this.loadData();
        }
    }

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }


    trackByKey = (_: number, m: { key: string }) => m.key;

    trackByTitle = (_: number, it: ModalItem) =>
        it.kind === 'collaborator' ? it.id :
            it.kind === 'output' ? (it.doc_num || `${it.title}-${it.year ?? ''}`) :
                it.title;

    ngOnInit() {
        this.mapping();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.products = this.data.products;
        this.periodEnd = this.period.end;
        this.periodStart = this.period.start;
        this.recalculate();
        this.loadData();
    }

    private recalculate() {
        try {
            this.filtered = this.products.filter(p => {
                const year = Number(p.pub_year);
                return year >= this.periodStart && year <= this.periodEnd;
            });

            const totalOutputs = this.filtered.length;
            const papers = this.filtered.filter(p => p.category === 'paper').length;
            const patents = this.filtered.filter(p => p.category === 'patent').length;
            const reports = this.filtered.filter(p => p.category === 'report').length;

            const institutions = new Set(
                this.filtered.map(p => p.org_id).filter((x: any) => !!x)
            ).size;

            const collaborators = this.getCollaboratorIds().length;

            const values: Record<string, number> = {
                totalOutputs,
                papers,
                patents,
                reports,
                institutions,
                collaborators,
            };

            this.metrics = METRIC_META.map(meta => ({
                key: meta.key,
                label: meta.label,
                iconSrc: meta.iconSrc,
                unit: meta.unit,
                group: meta.group,
                value: values[meta.key] ?? 0.
            }));

            this.outputM = this.metrics.filter(m => m.group === 'outputs');
            this.collabM = this.metrics.filter(m => m.group === 'collab');
            this.etcM = this.metrics.filter(m => m.group === 'etc');

            this.service.render();
        } catch (err) {
            toastr.error('데이터 계산 중 오류가 발생했습니다.');
            this.metrics = [];
        }
    }

    private getCollaboratorIds(): string[] {
        return Array.from(new Set(
            this.filtered
                .flatMap(p => (p.auth_list ?? '').toString().replace(/\s+/g, '').split(';'))
                .filter((aid: string) => aid && aid !== this.researcher?.auth_id)
        ));
    }

    public goResearcherDetail(user: { id: string }) {
        if (!user?.id) return;
        window.location.href = `/detail/${user.id}`;
    }

    public formatOrg(org: string, limit = 3): string {
        if (!org) return '';

        const parts = org
            .split(',')
            .map(x => x.trim())
            .filter(Boolean);

        if (parts.length <= limit) {
            return parts.join(', ');
        }

        return parts.slice(0, limit).join(', ') + ' …';
    }

    // ===== 모달 로직 =====
    async openMetric(key: string) {
        const meta = METRIC_META.find(m => m.key === key);
        this.modalTitle = meta?.label ?? '상세 보기';
        this.modalSubtitle = `${this.periodStart}년 ~ ${this.periodEnd}년`;
        this.modalItems = [];
        this.modalMessage = null;
        this.modalOpen = true;
        
        if (key === 'institutions') {
            const ids: string[] = [];
            const seen = new Set<string>();
            for (const p of this.filtered) {
                const oid = (p.org_id ?? '').toString().trim();
                if (oid && !seen.has(oid)) {
                    seen.add(oid);
                    ids.push(oid);
                }
            }

            if (ids.length === 0) {
                this.modalMessage = '표시할 데이터가 없습니다.';
                this.service.render();
                return;
            }

            try {
                const { code, data } = await wiz.call("get_organizations", {
                    ids: ids.join(",")
                });


                if (code === 200 && data?.organizations) {
                    const names = data.organizations.map((o: any) => o.display_name || o.org_id);
                    names.sort((a: string, b: string) => a.localeCompare(b, 'ko'));
                    this.modalItems = names.map((n: string) => ({ kind: 'organization', title: n }));
                } else {
                    this.modalMessage = '기관 정보를 불러오지 못했습니다.';
                }
            } catch (err) {
                console.error('get_organizations error:', err);
                this.modalMessage = '기관 정보를 불러오는 중 오류가 발생했습니다.';
            }
            this.service.render();
            return;
        }

        if (key === 'collaborators') {
            const ids = this.getCollaboratorIds();
            if (ids.length === 0) {
                this.modalMessage = '표시할 데이터가 없습니다.';
                this.service.render();
                return;
            }

            try {
                const { code, data } = await wiz.call("get_collaborators", { ids: ids.join(",") });

                if (code === 200 && Array.isArray(data?.authors)) {
                    const items: CollaboratorModalItem[] = data.authors.map((a: any) => ({
                        kind: 'collaborator',
                        id: a.id,
                        name: a.name || a.id,
                        org: Array.isArray(a.orgs) && a.orgs.length
                            ? a.orgs.map((o: any) => o.org_name || o.org_id).join(', ')
                            : '소속 정보 없음'
                    }));

                    items.sort((x, y) => x.name.localeCompare(y.name, 'ko') || x.org.localeCompare(y.org, 'ko'));
                    this.modalItems = items;
                    this.modalMessage = null;
                } else {
                    this.modalMessage = '협력 연구자 정보를 불러오지 못했습니다.';
                }
            } catch (e) {
                console.error(e);
                this.modalMessage = '협력 연구자 정보를 불러오는 중 오류가 발생했습니다.';
            }

            this.service.render();
            return;
        }

        const { items, message } = this.getDetailsForKey(key);
        this.modalItems = items ?? [];
        this.modalMessage = message ?? null;
        this.service.render();
    }

    public closeModal() {
        this.modalOpen = false;
        this.modalItems = [];
        this.modalMessage = null;
        this.modalTitle = '';
        this.modalSubtitle = '';
        this.service.render();
    }

    private getDetailsForKey(key: string): { items?: ModalItem[]; message?: string } {
        const prepareMsg = () => ({ message: '준비 중인 서비스 입니다.' });

        const pickTitles = (list: any[]) => {
            const tuples = list.map(p => {
                const y = Number(p.pub_year);
                return {
                    title: (p.title || p.name || p.kr_title || p.en_title || '').toString().trim(),
                    year: isNaN(y) ? undefined : y,
                    doc_num: p.doc_num,
                    category: p.category
                };
            }); // .filter(t => t.title.length > 0);

            // 최신 연도 우선, 동일 연도는 사전순
            tuples.sort((a, b) => ((b.year ?? -Infinity) - (a.year ?? -Infinity)) || a.title.localeCompare(b.title, 'ko'));

            // 그대로 객체로 반환
            return tuples.map(t => ({ kind: 'output', title: t.title, doc_num: t.doc_num, category: t.category, year: t.year })) as OutputModalItem[];
        };

        const pickInstitutions = (list: any[]) => {
            const names = list
                .map(p => (p.org_name || p.org || p.org_kor || p.org_eng || p.org_id || '').toString().trim())
                .filter(n => n.length > 0);
            const uniq = Array.from(new Set(names));
            uniq.sort((a, b) => a.localeCompare(b, 'ko'));
            return uniq.map(n => ({ title: n })) as ModalItem[];
        };

        switch (key) {
            case 'papers': {
                const items = pickTitles(this.filtered.filter(p => p.category === 'paper'));
                return { items };
            }
            case 'patents': {
                const items = pickTitles(this.filtered.filter(p => p.category === 'patent'));
                return { items };
            }
            case 'reports': {
                const items = pickTitles(this.filtered.filter(p => p.category === 'report'));
                return { items };
            }
            case 'institutions': {
                const items = pickInstitutions(this.filtered);
                return { items };
            }
            case 'collaborators':
            case 'topics':
            case 'recommendations':
                return prepareMsg();

            case 'totalOutputs':
            default: {
                const items = pickTitles(this.filtered);
                return { items };
            }
        }
    }

    private loadData() {
        if (!this.products) return;

        // 1) 기간 내 products만 필터링
        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        // 카테고리별 분류
        const papers = filtered.filter(p => p.category === 'paper');
        const patents = filtered.filter(p => p.category === 'patent');
        const reports = filtered.filter(p => p.category === 'report');

        // --- 세부 분류 집계 ---
        const paperDetails: Record<string, number> = {};
        for (const p of papers) {
            // const key = p.kr_journal?.trim() || p.en_journal?.trim() || '기타';
            const key = '논문';
            paperDetails[key] = (paperDetails[key] || 0) + 1;
        }

        const patentDetails: Record<string, number> = {};
        for (const p of patents) {
            // TODO: 국내/국제 구분 로직이 있으면 반영
            // const key = p.kr_publisher?.trim() || p.en_publisher?.trim() || '특허';
            const key = '특허';
            patentDetails[key] = (patentDetails[key] || 0) + 1;
        }

        const reportDetails: Record<string, number> = {};
        for (const p of reports) {
            // const key = p.kr_publisher?.trim() || p.en_publisher?.trim() || '보고서';
            const key = '보고서';
            reportDetails[key] = (reportDetails[key] || 0) + 1;
        }

        // --- 상위 카테고리별 합산 ---
        this.achieveData = [
            { label: '논문', value: papers.length },
            { label: '특허', value: patents.length },
            { label: '보고서', value: reports.length },
        ];

        // --- 차트에 넣을 details 구조 ---
        const datasetDetails: any = {
            '논문': Object.entries(paperDetails).map(([label, value]) => ({ label, value })),
            '특허': Object.entries(patentDetails).map(([label, value]) => ({ label, value })),
            '보고서': Object.entries(reportDetails).map(([label, value]) => ({ label, value })),
        };

        this.renderChart(datasetDetails);
    }

    private renderChart(details: any): void {
        if (this.chartPie) this.chartPie.destroy();
        this.chartPie = new Chart('pieChart', {
            type: 'pie',
            data: {
                labels: this.achieveData.map(d => d.label),
                datasets: [{
                    data: this.achieveData.map(d => d.value),
                    backgroundColor: ['#5381F2', '#4FD1B8', '#FFBCF9'],
                    borderWidth: 0,
                    details: details
                }]
            },
            options: {
                responsive: true,
                plugins: {
                    tooltip: {
                        enabled: false,
                        external: (ctx) => this.renderCustomTooltip(ctx)
                    },
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                            boxWidth: 7,
                            boxHeight: 7,
                            color: '#707988',
                            font: {
                                size: 14,
                            },
                            padding: 14,
                        }
                    }
                }
            }
        } as ChartConfiguration);
    }

    // 커스텀 hover 툴팁
    private renderCustomTooltip(context: any) {
        let tooltipEl = document.getElementById('chartjs-custom-tooltip');
        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-custom-tooltip';
            tooltipEl.className = 'rounded-lg shadow-[0px_3px_15px_#1A2C7633] bg-white p-2';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.zIndex = '1000';
            document.body.appendChild(tooltipEl);
        }

        const { chart, tooltip } = context;

        if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
        }

        const dataset: any = chart.data.datasets[0];
        const label = tooltip.dataPoints?.[0]?.label;

        let innerHtml = '<div class="flex flex-col gap-1">';
        if (dataset.details && dataset.details[label]) {
            dataset.details[label].forEach((d: any) => {
                innerHtml += `
                    <div class="flex justify-between gap-4 text-[14px] leading-[18px]">
                        <span class="text-[#707988]">${d.label}</span>
                        <span class="font-semibold">${d.value}건</span>
                    </div>`;
            });
        }
        innerHtml += '</div>';

        tooltipEl.innerHTML = innerHtml;

        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
        tooltipEl.style.opacity = '1';
        tooltipEl.style.left = positionX + tooltip.caretX + 'px';
        tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    }

    // 제목 링크에 사용할 URL 생성기
    public scienceOnUrl(p: any): string {
        const cn = p?.doc_num || '';
        if (!cn) return '#';

        switch (p?.category) {
            case 'report':
                return `https://scienceon.kisti.re.kr/srch/selectPORSrchReport.do?cn=${cn}`;
            case 'paper':
                return `https://scienceon.kisti.re.kr/srch/selectPORSrchArticle.do?cn=${cn}`;
            case 'patent':
                return `https://scienceon.kisti.re.kr/srch/selectPORSrchPatent.do?cn=${cn}`;
            default:
                return '#';
        }
    }


    // ESC 전역 닫기(안전망)
    @HostListener('window:keydown.escape', ['$event'])
    onEsc(_e: KeyboardEvent) {
        if (this.modalOpen) this.closeModal();
    }
}

export default PortalOverviewWidgetOutputsComponent;